import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CircularTimer from "./CircularTimer";
import { InfoCard } from "./InfoCard";
import { useAssessmentSubmission } from "../hooks";

export const DetailCards = (props) => {
  const { t } = useTranslation();
  const { totalQuestions } = props;
  const state = useSelector((state) => state.assessment);
  const { handleSubmit, submitLoading } = useAssessmentSubmission();

  return (
    <div className="flex w-full flex-wrap lg:flex-nowrap lg:flex-col lg:w-1/5 gap-4 rounded-lg justify-between ">
      {/* CR-03: this passed onTimeUp, which CircularTimer has never accepted - the prop
          it reads is onTimerEnd - so nothing at all happened when a question's time ran
          out. Nothing should: the question stays open and the clock counts the overtime
          up in amber. The prop is gone rather than renamed, so the intent is explicit. */}
      <CircularTimer
        questionIndex={state.currentQuestion}
        type={1}
        title={t("assessment.qTime")}
      />
      <CircularTimer
        questionIndex={state.initialTimes.length - 1}
        onTimerEnd={() => {
          if (state.initialTimes[state.initialTimes.length - 1] != 0)
            handleSubmit(true);
        }}
        type={1}
        title={t("assessment.totalTime")}
      />
      <InfoCard title={t("assessment.questions")} info={totalQuestions} />
    </div>
  );
};
